import {getCollection, getCollectionRef, getDoc, getDocRef} from '../libs/firestore';


function getScreeners(projectId: string | string[] | undefined, modelId: string | string[] | undefined) {
  return getCollectionRef(`projects/${projectId}/models/${modelId}/screeners`, 'time');
}

function getScreener(projectId: string | string[] | undefined, modelId: string | string[] | undefined) {
  return getDocRef(`projects/${projectId}/models/${modelId}`)
}

function getLatestScreener(projectId: string, modelId: string) {
  return getCollection(`projects/${projectId}/models/${modelId}/screeners`, 'time', 1).then((res) => {
    return res.docs[0].data();
  });
}

export {getScreeners, getScreener, getLatestScreener};
